export default "__VITE_ASSET__5fa1022d__"